import { create } from 'zustand';
import { persist } from 'zustand/middleware';
export const useUserPreferencesStore = create()(persist((set, get) => ({
    // Initial state
    preferences: [],
    isLoading: false,
    error: null,
    lastFetched: null,
    // Actions
    setPreferences: (preferences) => set({
        preferences,
        lastFetched: Date.now(),
        error: null,
    }),
    addPreference: (preference) => set((state) => ({
        preferences: [...state.preferences, preference],
    })),
    updatePreference: (preference) => set((state) => ({
        preferences: state.preferences.map((p) => p.id === preference.id ? preference : p),
    })),
    removePreference: (id) => set((state) => ({
        preferences: state.preferences.filter((p) => p.id !== id),
    })),
    clearPreferences: () => set({
        preferences: [],
        lastFetched: null,
        error: null,
    }),
    setLoading: (isLoading) => set({ isLoading }),
    setError: (error) => set({ error }),
    // Helper getters
    getPreference: (componentName, preferenceKey) => {
        const state = get();
        const preference = state.preferences.find((p) => p.componentName === componentName && p.preferenceKey === preferenceKey);
        return preference?.preferenceValue ?? null;
    },
    getPreferencesByComponent: (componentName) => {
        const state = get();
        const componentPreferences = state.preferences.filter((p) => p.componentName === componentName);
        const result = {};
        componentPreferences.forEach((p) => {
            result[p.preferenceKey] = p.preferenceValue;
        });
        return result;
    },
    getAllPreferences: () => {
        const state = get();
        const result = {};
        state.preferences.forEach((p) => {
            if (!result[p.componentName]) {
                result[p.componentName] = {};
            }
            result[p.componentName][p.preferenceKey] = p.preferenceValue;
        });
        return result;
    },
}), {
    name: 'prototype-user-preferences', // localStorage key
    partialize: (state) => ({
        preferences: state.preferences,
        lastFetched: state.lastFetched,
    }),
}));
// Selectors
export const selectPreference = (componentName, preferenceKey) => (state) => state.getPreference(componentName, preferenceKey);
export const selectComponentPreferences = (componentName) => (state) => state.getPreferencesByComponent(componentName);
export const selectAllPreferences = (state) => state.getAllPreferences();
